import React, { useState, useEffect, useContext } from 'react'
import Table from "components/Table/Table";
import UserDetailsAPI from 'apis/userDetails/UserDetails';
import Context from 'context/context';
import searchIcon from "assets/img/Search_Icon.png";
import { Styles } from './styles'
// import { toast } from "react-toastify";
import { CSVLink } from 'react-csv';
import * as moment from "moment";
import { exportHeaders } from './export';
import useDebounce from "helpers/useDebounce";


import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import MenuItem from "@material-ui/core/MenuItem";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Badge from "@material-ui/core/Badge";

// material-ui icons
import Grid from "@material-ui/core/Grid";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { blockInvalidCharForText } from 'helpers/blockInvalidCharForText';

import { useTranslation } from 'react-i18next';
// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
        background: "#ededed",
      },
    },
  },
})(TextField);



function UserDetails() {
  const { getUserDetailsAPI, searchAPI, filterAPI, exportAPI } = UserDetailsAPI()
  const { state, dispatch } = useContext(Context)
  const classes = Styles()
  const [data, setData] = useState([])
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true)
  const [searchValue, setSearchValue] = useState("")
  const [response, setResponse] = useState({
    filter: false
  })
  const [filterCard, setFilterCard] = useState(false)
  const [loyaltyRole, setLoyaltyRole] = useState('')
  const [filter, setFilter] = useState(false)
  const [superAdmin, setSuperAdmin] = useState(false)
  const [userAdmin, setUserAdmin] = useState(false)
  const [approverFlag, setApproverFlag] = useState(false)
  const [budgeterFlag, setBudgeterFlag] = useState(false)
  const [reportAccessFlag, setReportAccessFlag] = useState(false)
  const [onlinePaymentFlag, setOnlinePaymentFlag] = useState(false)
  const [advancedMngtFlag, setAdvancedMngtFlag] = useState(false)
  const [masterUserFlag, setMasterUserFlag] = useState(false)
  const [exportData, setExportData] = useState([])
  const searchBounceValues = useDebounce(searchValue);
  const { t, i18n } = useTranslation()
  useEffect(() => {
    if (filter) {
      handleFilter()
    }
    else if (searchBounceValues && searchBounceValues.length > 0) {
      handleSearch()
    } else {
      getUserDetails()
    }
  }, [searchBounceValues, offset])

  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "USER DETAILS"],
    });
  }, []);

  async function getUserDetails() {
    try {
      setLoading(true)
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };

      dispatch({ type: "SET_LOADING", payload: true });
      let res = await getUserDetailsAPI(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setResponse({ filter: false });
        setLoading(false)
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  }

  async function handleSearch() {
    try {
      setLoading(true)
      let values;
      values = {
        searchValue,
        offset: (offset - 1) * 10,
        limit: 10,
      };

      dispatch({ type: "SET_LOADING", payload: true });
      let res = await searchAPI(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setResponse({ filter: false });
        setLoading(false)
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  }

  async function handleFilter() {
    try {
      setLoading(true)
      setFilter(true)
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10,
        superAdmin,
        userAdmin,
        approverFlag,
        budgeterFlag,
        reportAccessFlag,
        onlinePaymentFlag,
        advancedMngtFlag,
        masterUserFlag
      };

      if (loyaltyRole && loyaltyRole.length > 0) {
        values = {
          ...values,
          loyaltyRole
        }
      }

      dispatch({ type: "SET_LOADING", payload: true });
      let res = await filterAPI(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setResponse({ filter: true });
        setLoading(false)
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (err) {
      console.log({ err });
    }
  }

  async function handleExport() {
    try {
      setLoading(true)
      let values = {};
      if (searchValue && searchValue.length > 0 && !filter) {
        values = {
          ...values,
          searchValue
        }
      }
      if (filter) {
        values = {
          superAdmin,
          userAdmin,
          approverFlag,
          budgeterFlag,
          reportAccessFlag,
          onlinePaymentFlag,
          advancedMngtFlag,
          masterUserFlag
        };
        if (loyaltyRole && loyaltyRole.length > 0) {
          values = {
            ...values,
            loyaltyRole
          }
        }
      }
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await exportAPI(values);
      if (res) {
        console.log({ exportData: res.data });
        setExportData(res.data);
        setLoading(false)
        dispatch({ type: "SET_LOADING", payload: false });
        return true
      }
      return false
    } catch (err) {
      console.log({ err });
      return false
    }
  }


  let tableHeading = [
    "Shipto",
    "First Name",
    "Last Name",
    "Email",
    "Super Admin",
    "User Admin",
    "Approver Flag",
    "Budgeter Flag",
    "Report Access Flag",
    "Online Payment Flag",
    "Advanced Account Mngt Flag",
    "Master User Flag",
    "Loyalty Role"
  ];
  //console.log({ data });

  const handlePagination = (value) => {
    setOffset(value);
  };


  return (
    <>
      <Grid xs={12} sm={12} lg={12} className={classes.topGrid}>
        <Grid>
          <CssTextField
            id="enterPassword"
            placeholder={t('Search for Shipto or Email')}
            onKeyDown={blockInvalidCharForText}
            type={"text"}
            variant="outlined"
            autoComplete="off"
            className={classes.searchInput}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {searchValue.length > 0 ? (
                    <CloseOutlinedIcon
                      className={classes.searchInputIcon}
                      onClick={() => {
                        setSearchValue("");
                        setOffset(1);
                        getUserDetails();
                      }}
                    />
                  ) : (
                    <img
                      src={searchIcon}
                      alt=""
                      width="20px"
                      className={classes.searchInputIcon}
                    />
                  )}
                </InputAdornment>
              ),
            }}
            value={searchValue}
            onChange={(e) => {
              e.target.value.replace(/\s+/g, "").length == 0
                ? setSearchValue("")
                : setSearchValue(e.target.value);
              if (e.target.value.length == 0) {
                getUserDetails();
              }
            }}
            onClick={() => {
              setOffset(1);
            }}
          />
          <Button
            className={`${classes.filterBtn} dash-1-filter-btn`}
            onClick={() => {
              setFilterCard(!filterCard);
              if (!filter) {
                setOffset(1);
                setSuperAdmin(false)
                setUserAdmin(false)
                setApproverFlag(false)
                setBudgeterFlag(false)
                setReportAccessFlag(false)
                setOnlinePaymentFlag(false)
                setAdvancedMngtFlag(false)
                setMasterUserFlag(false)
                setLoyaltyRole("")
              }
            }}
          >
            {t('Filter')}
            {response["filter"] && (
              <Badge
                badgeContent={count == 0 ? null : count < 1000 ? response["filter"] && count : '999+'}
                color="error"
                classes={{ badge: classes.badge }}
                max={999999}
                className={classes.badges}
              ></Badge>
            )}
          </Button>
        </Grid>
        <Grid>
          <CSVLink
            id="csv"
            data={exportData}
            headers={exportHeaders.map((head) => {
              return { ...head, label: t(head.label) }
            })}
            filename={
              t(`User Details`) +
              " " +
              moment(new Date()).format("MM-DD-YYYY,h:mm A") +
              ".csv"
            }
            className={classes.CSVlink}
          />
          <button
            disabled={loading}
            className={classes.exportBtn}
            onClick={async () => {
              let res = await handleExport();
              if (res) {
                document.getElementById("csv").click();
              }
            }}
          >
            {t('Export')}
          </button>
        </Grid>
      </Grid>
      {filterCard && (
        <div className={classes.filterCardDiv}>
          <Grid container spacing={0}>
            <Grid item xs={12} style={{ float: "right" }}>
              <Card className={classes.filterCard}>
                <Grid
                  container
                  spacing={2}
                  className={classes.filterCardGridContainer}
                >
                  <Grid item sm={3} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t('Loyalty Role')}</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={loyaltyRole}
                      onChange={(e) => {
                        setLoyaltyRole(e.target.value)
                      }}
                    >
                      <MenuItem value={"Consent Admin"}>{t('Consent Admin')}</MenuItem>
                      <MenuItem value={"Loyalty Admin"}>{t('Loyalty Admin')}</MenuItem>
                      <MenuItem value={"Customer"}>{t('Customer')}</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid container item sm={7} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t('One Web Role')}</div>
                    <div style={{ display: 'flex' }}>
                      <div>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="primary"
                              checked={superAdmin}
                              onChange={() => setSuperAdmin(!superAdmin)}
                            />
                          }
                          label={t('Super Admin')}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="primary"
                              checked={userAdmin}
                              onChange={() => setUserAdmin(!userAdmin)}
                            />
                          }
                          label={t('User Admin')}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="primary"
                              checked={approverFlag}
                              onChange={() => setApproverFlag(!approverFlag)}
                            />
                          }
                          label={t('Approver Flag')}
                        />
                      </div>
                      <div>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="primary"
                              checked={budgeterFlag}
                              onChange={() => setBudgeterFlag(!budgeterFlag)}
                            />
                          }
                          label={t('Budgeter Flag')}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="primary"
                              checked={reportAccessFlag}
                              onChange={() => setReportAccessFlag(!reportAccessFlag)}
                            />
                          }
                          label={t('Report Access Flag')}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="primary"
                              checked={onlinePaymentFlag}
                              onChange={() => setOnlinePaymentFlag(!onlinePaymentFlag)}
                            />
                          }
                          label={t('Online Payment Flag')}
                        />
                      </div>
                      <div>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="primary"
                              checked={advancedMngtFlag}
                              onChange={() => setAdvancedMngtFlag(!advancedMngtFlag)}
                            />
                          }
                          label={t('Advanced Account Mngt Flag')}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="checkedB"
                              color="primary"
                              checked={masterUserFlag}
                              onChange={() => setMasterUserFlag(!masterUserFlag)}
                            />
                          }
                          label={t('Master User Flag')}
                        />
                      </div>
                    </div>
                  </Grid>
                  <Grid
                    item
                    sm={2}
                    xs={12}
                    className={classes.filterCardBtnGrid}
                  >
                    <Grid container spacing={0}>
                      <Grid item xs={12}>
                        <Button
                          className={classes.filterCardApplyBtn}
                          onClick={() => {
                            handleFilter();
                            setCount(0);
                            setOffset(1);
                          }}
                        >
                          {t('Apply')}
                        </Button>
                      </Grid>
                      {filter && (
                        <Grid item xs={12}>
                          <Button
                            className={classes.filterCardResetBtn}
                            onClick={() => {
                              setOffset(1);
                              setFilterCard(false);
                              setFilter(false)
                              setSuperAdmin(false)
                              setUserAdmin(false)
                              setApproverFlag(false)
                              setBudgeterFlag(false)
                              setReportAccessFlag(false)
                              setOnlinePaymentFlag(false)
                              setAdvancedMngtFlag(false)
                              setMasterUserFlag(false)
                              setLoyaltyRole("")
                              getUserDetails()
                            }}
                          >
                            {t('Reset')}
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </div>
      )}
      <div style={{ marginTop: 20 }}>
        {!loading ? <Table
          headings={tableHeading.map((i) => {
            return <div key={t(i)}>{t(i)}</div>
          })}
          data={data &&
            data.length > 0 &&
            data.map((p) => [
              [p?.customer_account_number],
              [p?.first_name],
              [p?.last_name],
              [p?.email],
              p?.super_administrator ?
                [<CheckCircleIcon style={{ color: 'green' }} />] :
                [<HighlightOffIcon style={{ color: 'red' }} />],
              p?.user_admin ?
                [<CheckCircleIcon style={{ color: 'green' }} />] :
                [<HighlightOffIcon style={{ color: 'red' }} />],
              p?.approver ?
                [<CheckCircleIcon style={{ color: 'green' }} />] :
                [<HighlightOffIcon style={{ color: 'red' }} />],
              p?.budgeter ?
                [<CheckCircleIcon style={{ color: 'green' }} />] :
                [<HighlightOffIcon style={{ color: 'red' }} />],
              p?.report_access ?
                [<CheckCircleIcon style={{ color: 'green' }} />] :
                [<HighlightOffIcon style={{ color: 'red' }} />],
              p?.online_payment ?
                [<CheckCircleIcon style={{ color: 'green' }} />] :
                [<HighlightOffIcon style={{ color: 'red' }} />],
              p?.advanced_account_management == "1" && p?.advanced_account_management !== "NULL" ?
                [<CheckCircleIcon style={{ color: 'green' }} />] :
                [<HighlightOffIcon style={{ color: 'red' }} />],
              p?.master_user ?
                [<CheckCircleIcon style={{ color: 'green' }} />] :
                [<HighlightOffIcon style={{ color: 'red' }} />],
              [p?.role_name]
            ])}
          offset={offset}
          count={
            (count / 10) % 1 == 0
              ? Math.floor(count / 10)
              : Math.floor(count / 10 + 1)
          }
          handlePagination={handlePagination}
        /> :
          <div style={{ height: '25vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <h2>{t('Loading...')}</h2>
          </div>}
      </div>
    </>
  )
}

export default UserDetails